/**
 * Negotiation type / priority / stage options — values verbatim from the v4
 * backend enums (labels are the EN equivalents of the legacy i18n keys). Used by
 * the create-negotiation dialog so submitted values match what the API accepts.
 */

export interface NegotiationOption {
  value: string;
  label: string;
}

export const NEGOTIATION_TYPE_OPTIONS: NegotiationOption[] = [
  { value: 'nda', label: 'NDA' },
  { value: 'quote_request', label: 'Quote Request' },
  { value: 'bom_approval', label: 'BOM Approval' },
  { value: 'term_negotiation', label: 'Term Negotiation' },
  { value: 'contract_draft', label: 'Contract Draft' },
  { value: 'other', label: 'Other' },
];

export const NEGOTIATION_PRIORITY_OPTIONS: NegotiationOption[] = [
  { value: 'critical', label: 'Critical' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
  { value: 'none', label: 'None' },
];

export const NEGOTIATION_STAGE_OPTIONS: NegotiationOption[] = [
  { value: 'initial_contact', label: 'Initial Contact' },
  { value: 'requirement_gathering', label: 'Requirement Gathering' },
  { value: 'technical_evaluation', label: 'Technical Evaluation' },
  { value: 'commercial_discussion', label: 'Commercial Discussion' },
  { value: 'legal_review', label: 'Legal Review' },
  { value: 'final_approval', label: 'Final Approval' },
  { value: 'contract_preparation', label: 'Contract Preparation' },
];
